//GeneratorFlag:[NoChange]
<template>
	<div>kaveh.app.toolbar.cms.notification</div>
</template>